module.exports = __webpack_public_path__ + "static/media/magic-stick-fill-white.43b037ac.svg";